import { DocumentsQuery } from "api";

/**
 * Converts filter params (from useTableFilters.getQueryParams()) to DocumentsQuery shape.
 * Applies aiExtraction normalization and numeric conversion for pages/dataEntries.
 */
export const filterParamsToQuery = (params: Record<string, any>): Partial<DocumentsQuery> => {
  if (!params || Object.keys(params).length === 0) return {};

  const convertStringToNumberIfNumeric = (input: any): number | undefined => {
    if (typeof input === "number" && Number.isFinite(input) && input >= 0) return input;
    if (typeof input !== "string") return undefined;
    const trimmed = input.trim();
    if (trimmed === "") return undefined;
    const parsed = parseFloat(trimmed);
    if (Number.isNaN(parsed) || !Number.isFinite(parsed) || parsed < 0) return undefined;
    if (parsed.toString() !== trimmed) return undefined;
    return parsed;
  };

  const res: Partial<DocumentsQuery> = {};

  if (params.fileName != null && params.fileName !== "") res.fileName = String(params.fileName);
  if (params.siteName != null && params.siteName !== "") res.siteName = String(params.siteName);
  if (params.utilityName != null && params.utilityName !== "") res.utilityName = String(params.utilityName);
  if (params.uploader != null && params.uploader !== "") res.uploader = String(params.uploader);
  if (params.uploadedAt != null && params.uploadedAt !== "") res.uploadedAt = String(params.uploadedAt);

  const pagesVal = convertStringToNumberIfNumeric(params.pages);
  if (pagesVal !== undefined) res.pages = pagesVal;

  const dataEntriesVal = convertStringToNumberIfNumeric(params.dataEntries);
  if (dataEntriesVal !== undefined) res.dataEntries = dataEntriesVal;

  if (params.dataEntriesStatus != null && params.dataEntriesStatus !== "") res.dataEntriesStatus = String(params.dataEntriesStatus);

  if (params.aiExtraction != null && params.aiExtraction !== "") {
    const v = String(params.aiExtraction).trim();
    res.aiExtraction = v.toLowerCase() === "na" ? "NA" : v.replace("%", "");
  }
  if (params.aiAlgorithm != null && params.aiAlgorithm !== "") res.aiAlgorithm = String(params.aiAlgorithm);

  return res;
};
